"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagedOptions = usePagedOptions;
exports.useAccumulatedOptions = useAccumulatedOptions;
var react_1 = require("react");
var pages_1 = require("../constants/pages");
// Owns the query state behind a server-driven dropdown, so the list it shows comes from the service
// rather than a fixed slab filtered in the browser.
function usePagedOptions(size) {
    if (size === void 0) { size = pages_1.comboInitialPaginationValues.size; }
    var _a = (0, react_1.useState)(1), page = _a[0], setPage = _a[1];
    var _b = (0, react_1.useState)(""), searchString = _b[0], setSearchString = _b[1];
    var _c = (0, react_1.useState)(""), debouncedSearch = _c[0], setDebouncedSearch = _c[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () { return setDebouncedSearch(searchString); }, 400);
        return function () { return clearTimeout(timer); };
    }, [searchString]);
    // a new term describes a different result set, so the old page number no longer means anything
    var onSearch = (0, react_1.useCallback)(function (term) {
        setSearchString(term);
        setPage(1);
    }, []);
    var onNextPage = (0, react_1.useCallback)(function () { return setPage(function (previous) { return previous + 1; }); }, []);
    var queryArgs = { page: page, size: size, search_string: debouncedSearch };
    return { queryArgs: queryArgs, onSearch: onSearch, onNextPage: onNextPage, isFirstPage: page === 1 };
}
// A combo box must keep every option it has shown, otherwise paging would drop the entry backing the
// current selection and the field would render a bare id.
// pageOptions must be memoised by the caller: an array rebuilt every render would re-run this forever.
function useAccumulatedOptions(pageOptions, isFirstPage) {
    var _a = (0, react_1.useState)([]), options = _a[0], setOptions = _a[1];
    (0, react_1.useEffect)(function () {
        setOptions(function (previous) {
            var merged = isFirstPage ? pageOptions : __spreadArray(__spreadArray([], previous, true), pageOptions, true);
            var byValue = new Map(merged.map(function (option) { return [option.value, option]; }));
            var next = Array.from(byValue.values());
            var isUnchanged = next.length === previous.length && next.every(function (option, index) { var _a; return option.value === ((_a = previous[index]) === null || _a === void 0 ? void 0 : _a.value); });
            return isUnchanged ? previous : next;
        });
    }, [pageOptions, isFirstPage]);
    return options;
}
